/* Ürün açıklaması: ilk 6 satır (mobilde 3), uzunsa "Read more" ile açılır, açıkken "Show less" ile kapanır.
   Kısa açıklamada düğme ve solma gölgesi hiç görünmez. JS yoksa açıklama tam gösterilir (<noscript>). */
class NilyaDesc extends HTMLElement {
  connectedCallback() {
    this.body = this.querySelector('.nilya-desc__body');
    this.button = this.querySelector('.nilya-desc__toggle');
    if (!this.body || !this.button) return;
    this.expanded = false;
    this.abort = new AbortController();
    this.button.addEventListener('click', () => this.toggle(), { signal: this.abort.signal });
    window.addEventListener('resize', () => this.measure(), { signal: this.abort.signal });
    window.addEventListener('load', () => this.measure(), { signal: this.abort.signal });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.measure());
    this.body.querySelectorAll('img').forEach((img) => img.addEventListener('load', () => this.measure(), { signal: this.abort.signal }));
    this.measure();
  }

  disconnectedCallback() {
    if (this.abort) this.abort.abort();
  }

  measure() {
    if (this.expanded) return;
    const overflow = this.body.scrollHeight > this.body.clientHeight + 4;
    this.classList.toggle('is-long', overflow);
    this.button.hidden = !overflow;
  }

  toggle() {
    this.expanded = !this.expanded;
    this.body.classList.toggle('is-clamped', !this.expanded);
    this.button.setAttribute('aria-expanded', String(this.expanded));
    this.button.querySelector('[data-more]').hidden = this.expanded;
    this.button.querySelector('[data-less]').hidden = !this.expanded;
    if (!this.expanded) {
      this.measure();
      // Kapatınca başlık ekranın üstünde kaldıysa geri getir
      if (this.getBoundingClientRect().top < 0) this.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  }
}
if (!customElements.get('nilya-desc')) customElements.define('nilya-desc', NilyaDesc);
